export default "__VITE_ASSET__BI6PB29b__"